import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FLink, Table, TableMobile } from '@components';
import { currency } from '@utils';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';
import { EmprestimoService } from '../../../../../common/services/emprestimo';

const service = new EmprestimoService();

export const Prestacoes = () => {
  const { id } = useParams();
  const location = useLocation();
  const { parcelas } = location.state;
  const { matricula, token, nome } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const [pdf, setPDF] = useState('');

  useEffect(() => {
    service
      .gerarPDFParcelasEmprestimo({
        matricula,
        token,
        nome,
        nContrato: id,
        parcelas,
      })
      .then((base64) => {
        setPDF(`data:application/pdf;base64,${base64}`);
      });
  }, [id, matricula, nome, parcelas, token]);

  return (
    <div className="card">
      <div className="card-body">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
        >
          voltar
        </FLink>
        <h3 className="ts-20 fw-bold text-black mb-2">
          Prestações do contrato: {id}
        </h3>
        <Table
          odd
          className="is-desktop mb-32"
          columns={[
            'Data',
            'Parcela',
            'Tipo',
            'Saldo Anterior',
            'Correção Saldo',
            'Juros',
            'Taxa do Fundo',
            'Saldo Corrigido',
            'Amortização',
            'Prestação',
            'Realizado',
            'Saldo Atual',
            'Valor em Aberto',
          ]}
        >
          {parcelas.map((parcela) => {
            return (
              <tr
                key={`${parcela.parcela}${parcela.data}${parcela.saldoAtual}`}
              >
                <td className="ts-12">
                  {format(new Date(parcela.data), 'dd/MM/yyyy')}
                </td>
                <td className="ts-12">{parcela.parcela}</td>
                <td className="ts-12">{parcela.tipo}</td>
                <td className="ts-12">{currency(parcela.saldoAnterior)}</td>
                <td className="ts-12">{currency(parcela.correcaoSaldo)}</td>
                <td className="ts-12">{currency(parcela.juros)}</td>
                <td className="ts-12">{currency(parcela.taxaFundo)}</td>
                <td className="ts-12">{currency(parcela.saldoCorrigido)}</td>
                <td className="ts-12">{currency(parcela.amortizacao)}</td>
                <td className="ts-12">{currency(parcela.prestacao)}</td>
                <td className="ts-12">{currency(parcela.realizado)}</td>
                <td className="ts-12">{currency(parcela.saldoAtual)}</td>
                <td className="ts-12">{currency(parcela.valorEmAberto)}</td>
              </tr>
            );
          })}
        </Table>
        {parcelas.map((parcela) => {
          return (
            <TableMobile
              className="mb-32"
              key={`${parcela.parcela}${parcela.data}${parcela.saldoAtual}`}
            >
              <div className="col-6">
                <div className="thead">Data</div>
                <div className="td">{parcela.data}</div>
              </div>
              <div className="col-6">
                <div className="thead">Parcela</div>
                <div className="td">{parcela.parcela}</div>
              </div>
              <div className="col-6">
                <div className="thead">Tipo</div>
                <div className="td">{parcela.tipo}</div>
              </div>
              <div className="col-6">
                <div className="thead">Saldo Anterior</div>
                <div className="td">{currency(parcela.saldoAnterior)}</div>
              </div>
              <div className="col-6">
                <div className="thead">Correção Saldo</div>
                <div className="td">{currency(parcela.correcaoSaldo)}</div>
              </div>
              <div className="col-6">
                <div className="thead">Juros</div>
                <div className="td">{currency(parcela.juros)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Taxa Fundo</div>
                <div className="td">{currency(parcela.taxaFundo)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Saldo Corrigido</div>
                <div className="td">{currency(parcela.saldoCorrigido)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Amortização</div>
                <div className="td">{currency(parcela.amortizacao)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Prestação</div>
                <div className="td">{currency(parcela.prestacao)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Realizado</div>
                <div className="td">{currency(parcela.realizado)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Saldo Atual</div>
                <div className="td">{currency(parcela.saldoAtual)}</div>
              </div>
              <div className="col-12">
                <div className="thead">Valor em Aberto</div>
                <div className="td">{currency(parcela.valorEmAberto)}</div>
              </div>
            </TableMobile>
          );
        })}
        <div className="col-12 col-sm-6 col-md-4 ms-0 ms-sm-auto">
          <a
            href={pdf}
            rel="noreferrer"
            target="_blank"
            download={id}
            title="Clique para baixar o pdf"
            className="ms-0 ms-md-3 aButton"
          >
            Baixar PDF
          </a>
        </div>
      </div>
    </div>
  );
};
